module.exports = __webpack_public_path__ + "static/img/congxinshengchengIcon.bdf175cb.svg";